import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=792ce70e&"
import script from "./FollowUp.vue?vue&type=script&lang=ts&"
export * from "./FollowUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792ce70e')) {
      api.createRecord('792ce70e', component.options)
    } else {
      api.reload('792ce70e', component.options)
    }
    module.hot.accept("./FollowUp.vue?vue&type=template&id=792ce70e&", function () {
      api.rerender('792ce70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/FollowUp.vue"
export default component.exports